import React from 'react'
import { RiInformationLine, RiRefreshLine } from 'react-icons/ri'
import LastFetched from '../../../components/LastFetched';
import { useParams } from 'react-router-dom';
import { useGlobalContext } from '../../../Contexts/GlobalContext';
import { useQuery } from '@tanstack/react-query';
import { getSurveyParticipantOverviewStats } from '../qualSurveysActions';
import { useState } from 'react';
import { Skeleton } from '@mui/material';

const ParticipantOverviewStatsCard = () => {
    const { id, type } = useParams();
    const { user } = useGlobalContext();
    const [reset, setReset] = useState(false);
    const organization = user?.organization?._id;
    const project = id;
    const {
        data: surveyParticipantOverviewStats,
        isLoading: surveyParticipantOverviewStatsLoading,
        isError: surveyParticipantOverviewStatsError,
    } = useQuery({
        queryFn: () => getSurveyParticipantOverviewStats({
            organizationID: organization,
            projectID: project,
            reset: reset,
        }),
        enabled: Boolean(id && type === "participant-management"),
        queryKey: ['project-participant-overview-stats', organization?.id, project, reset],
        staleTime: 10000,
        cacheTime: 15000,
    });
    const overviewCards = [
        {
            title: 'All Participants',
            count: surveyParticipantOverviewStats?.data?.all || 0,
            color: 'bg-blue-500',
        },
        {
            title: 'Draft Participants',
            count: surveyParticipantOverviewStats?.data?.draft || 0,
            color: 'bg-violet-400',
        },
        {
            title: 'Invited Participants',
            count: surveyParticipantOverviewStats?.data?.invited || 0,
            color: 'bg-purple-500',
        },
        {
            title: 'Started Participants',
            count: surveyParticipantOverviewStats?.data?.started || 0,
            color: 'bg-orange-500',
        },
        {
            title: 'Completed Participants',
            count: surveyParticipantOverviewStats?.data?.completed || 0,
            color: 'bg-green-500',
        },
        {
            title: 'Dropped Participants',
            count: surveyParticipantOverviewStats?.data?.dropped || 0,
            color: 'bg-red-500',
        },
        {
            title: 'Disqualified Participants',
            count: surveyParticipantOverviewStats?.data?.disqualified || 0,
            color: 'bg-indigo-700',
        },
    ];
    if (surveyParticipantOverviewStatsError) return null
    return (
        <div className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm">
            {/* Header */}
            <div className="flex items-start justify-between">
                <div>
                    <h2 className="text-md font-bold text-gray-900">Overview</h2>
                    <p className="mt-1 text-gray-500 text-xs">
                        A comprehensive summary of the participants in the survey.
                    </p>
                </div>

                <LastFetched
                    date={surveyParticipantOverviewStats?.lastFetched}
                    loading={surveyParticipantOverviewStatsLoading}
                    setReset={setReset}

                />
            </div>

            <div className="my-3 border-t border-gray-200" />

            {/* Cards */}
            <div className="grid grid-cols-7 gap-4">
                {overviewCards.map((card) => (
                    <div
                        key={card.title}
                        className="relative flex min-h-[120px] flex-col overflow-hidden rounded-xl border border-gray-200 bg-white p-3.5 shadow-sm"
                    >
                        {/* Left Color Bar */}
                        <div
                            className={`absolute left-0 top-0 h-full w-1 ${card.color}`}
                        />

                        <div className="flex items-start justify-between">
                            <h3 className="max-w-[140px] text-sm font-medium text-gray-600">
                                {card.title}
                            </h3>


                        </div>

                        {/* Push count to bottom */}
                        <p className="mt-auto text-2xl font-bold text-gray-900">
                            {surveyParticipantOverviewStatsLoading
                                ? <Skeleton className='w-10' /> :
                                card?.count}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default ParticipantOverviewStatsCard